import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["textContent"]

import { computed, onBeforeMount, ref, toRefs } from 'vue';
import Menu from 'primevue/menu';
import { useMessageCenterStore } from '@/store';
import { EMIT } from '@/enum';

interface MessageActions {
  messageId?: number;
  documentId?: string;
  action: string;
  createdAt: Date | string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageActions',
  props: {
    messageId: {},
    documentId: {},
    action: {},
    createdAt: {}
  },
  emits: [EMIT.DELETE_MESSAGE, EMIT.DELETE_MESSAGE_FILE],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const messageCenterStore = useMessageCenterStore();

const props = __props;

const { createdAt, messageId, documentId, action } = toRefs(props);
const menu = ref();
const reasonId = ref();
const confirmArchiveOpen = ref(false);
const loading = ref(false);

onBeforeMount(() => init());

const init = () => {
  loading.value = false;
  confirmArchiveOpen.value = false;
  reasonId.value = false;
};

const deleteFile = async () => {
  if (!documentId.value || !messageId.value) return;
  await messageCenterStore.deleteMessageFile(messageId.value, documentId.value);

  emit(EMIT.DELETE_MESSAGE);
};

const deleteMessage = async () => {
  if (!messageId.value) return;
  await messageCenterStore.deleteMessage(messageId.value);

  if (messageCenterStore?.error) {
    messageCenterStore.doToast(messageCenterStore?.error, 'Error', true);
    return;
  }

  emit(EMIT.DELETE_MESSAGE_FILE);
};

const isRecent = computed(() => {
  const created = new Date(createdAt.value).getTime();
  const now = Date.now();
  const diffMinutes = (now - created) / (1000 * 60);
  return diffMinutes < 60;
});

const menuItems = (() => {
  const eventToEmit = action.value;

  return [
    {
      label: 'Delete Message',
      icon: {
        name: 'trash',
        styles: 'inline-block text-lg text-blue-500',
      },
      styles: '',
      visible: eventToEmit === EMIT.DELETE_MESSAGE,
      command: deleteMessage,
    },
    {
      label: 'Delete File',
      icon: {
        name: 'trash',
        styles: 'inline-block text-lg text-blue-500',
      },
      styles: '',
      visible: eventToEmit === EMIT.DELETE_MESSAGE_FILE,
      command: deleteFile,
    },
  ];
})();

const toggle = (event: Event): void => menu.value.toggle(event);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (isRecent.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ml-3 cursor-pointer",
        onClick: toggle
      }, [
        _createVNode(_component_Icon, {
          name: "more_horiz",
          class: "text-lg p-1"
        }),
        _createVNode(_unref(Menu), {
          id: "overlay_menu",
          ref_key: "menu",
          ref: menu,
          model: _unref(menuItems),
          popup: true
        }, {
          item: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_1, [
              (item.command)
                ? (_openBlock(), _createElementBlock("a", _hoisted_2, [
                    _createElementVNode("span", {
                      class: "relative inline-block text-sm text-800",
                      textContent: _toDisplayString(item.label)
                    }, null, 8, _hoisted_3)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]))
    : _createCommentVNode("", true)
}
}

})